<script>
import baseMixin from '@/mixins/baseMixin'
import timesheetMixin from '@/mixins/timesheetMixin'
import { BookingStatus } from '@/shared/constants/booking/BookingStatus'

export default {
  name: 'TimesheetBookingTime',
  mixins: [baseMixin, timesheetMixin],
  props: {
    timesheet: {
      type: Object,
      required: true,
    },
  },
  computed: {
    compMainTimeString() {
      return this.generateFullBookingTimeString(
        this.getModifiedOrOriginalBookingDetails(
          this.timesheet,
          this.isLargeOrLower
        )
      )
    },
    showSubtext() {
      return (
        this.timesheet.bookingStatus ===
        BookingStatus.CANDIDATE_SUBMITTED_TIMESHEET_MODIFIED
      )
    },
    compSubTextTimeString() {
      return this.generateFullBookingTimeString(
        this.getOriginalBookingDetails(this.timesheet, this.isLargeOrLower)
      )
    },
  },
}
</script>

<template>
  <div>
    <p :class="['mb-0 ws-pre-wrap']">{{ compMainTimeString }}</p>
    <div v-if="showSubtext">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <p
            data-testid="timesheet-booking-time-subtext"
            v-bind="attrs"
            class="mb-0 caption ws-pre-wrap cursor-help text-decoration-line-through"
            v-on="on"
            >{{ compSubTextTimeString }}</p
          >
        </template>
        <span class="ws-pre-wrap">{{
          $t('timesheets.table.time.originalBookingTimeTooltip', [
            compSubTextTimeString,
          ])
        }}</span>
      </v-tooltip>
    </div>
  </div>
</template>
